import React, { useEffect } from "react";
import { AppBar, Toolbar, Typography, styled, Avatar } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import { useLocation, useNavigate } from "react-router";
import { Tooltip } from "antd";
import voyagerLogo from "../assets/voyager/voyagerLogo.png";

// Apply global styles
const GlobalStyles = styled("div")({
  "*": {
    margin: 0,
    padding: 0,
    boxSizing: "border-box",
  },
  "html, body": {
    height: "100%",
    overflow: "hidden",
  },
  "#root": {
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
});

// Custom styling for AppBar
const StyledAppBar = styled(AppBar)({
  // background: "var(--white-color)",
  background:"#032366",
  boxShadow: "none",
  height: 70,
  borderBottom: "1px solid #e0e0e0",
  zIndex: "1000",
});

// Custom styling for Toolbar
const StyledToolBar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  paddingLeft: 0,
});

// Main content styling
const MainContent = styled("div")({
  paddingTop: "70px",
  flex: 1,
  overflow: "hidden",
});

// Header component
const Header = ({ toggleDrawer }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Prevent body scrolling
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "";
    };
  }, []);

  // Logout function
  const onLogout = () => {
    window.history.replaceState(null, null, null);
    navigate("/", { state: {} });
  };

  // Convert string to color
  function stringToColor(string) {
    let hash = 0;
    let i;
    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    let color = "#";
    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
  }

  // Create avatar based on string
  function stringAvatar(name = "Guest") {
    return {
      sx: {
        bgcolor: stringToColor(name),
      },
      children: `${name.split("")[0].toUpperCase()}`,
    };
  }

  return (
    <GlobalStyles>
      <StyledAppBar position="fixed">
        <StyledToolBar>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            disableRipple
            // sx={{ mr: 2 }}
            onClick={toggleDrawer}
          >
            <img
              src={voyagerLogo}
              alt="Logo"
              style={{
                width: 120,
                height:60,
                marginBottom:13,
                marginTop:7,
              }}
            />
            <MenuIcon style={{ color: "var(--white-color)" }} />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            style={{ color: "var(--white-color)", fontWeight: "bold" , marginRight:20 }}
          >
            VOYAGER THERAPEUTICS-VDEP PROD
          </Typography>
          <div>
            <Tooltip placement="leftTop" title={location.state?.username}>
              <IconButton
                size="medium"
                aria-label="account of current user"
                aria-controls="menu-appbar"
                aria-haspopup="true"
              >
                <Avatar
                  {...stringAvatar(location.state?.username)}
                  style={{ width: 30, height: 30 }}
                />
              </IconButton>
            </Tooltip>
          </div>
        </StyledToolBar>
      </StyledAppBar>
      <MainContent></MainContent>
    </GlobalStyles>
  );
};

export default Header;
